<section class="payment-shell" dir="rtl" aria-labelledby="payment-title">
  <header class="payment-header">
    <div>
      <span class="payment-eyebrow"><span aria-hidden="true">✓</span> תשלום מאובטח</span>
      <h2 id="payment-title">{{ paymentTitle }}</h2>
      <p>השלב האחרון לפני שהמודעה שלכם עולה לאוויר</p>
    </div>
    <button type="button" class="close-button" (click)="closeDialog()" aria-label="סגירת חלון התשלום">×</button>
  </header>

  <div class="payment-layout">
    <aside class="plan-summary" aria-label="סיכום ההזמנה">
      @if (adsRoute?.image) {
        <div class="plan-summary__image">
          <img [src]="adsRoute.image" [alt]="adsRoute.title || 'המסלול שנבחר'">
        </div>
      } @else {
        <div class="plan-summary__icon" aria-hidden="true">
          <svg width="38" height="38" viewBox="0 0 24 24"><path d="M12 2l2.7 5.47 6.04.88-4.37 4.26 1.03 6.02L12 15.8l-5.4 2.83 1.03-6.02-4.37-4.26 6.04-.88L12 2z"/></svg>
        </div>
      }

      <span class="summary-label">המסלול שבחרתם</span>
      <h3>{{ (adsRoute?.title || 'הזמנה') | translate }}</h3>
      <div class="summary-price">
        <strong>{{ adsRoute?.price | number:'1.0-2' }}</strong><span>₪</span>
      </div>
      @if (durationLabel) { <span class="summary-duration">למשך {{ durationLabel }}</span> }

      @if (descriptionLines.length) {
        <ul class="summary-features">
          @for (line of descriptionLines; track line) {
            <li><span aria-hidden="true">✓</span>{{ line | translate }}</li>
          }
        </ul>
      }

      <div class="summary-total">
        <span>סה״כ לתשלום</span>
        <strong>{{ adsRoute?.price | number:'1.0-2' }} ₪</strong>
      </div>
    </aside>

    <div class="payment-form-panel">
      <div class="panel-title">
        <span class="panel-title__icon" aria-hidden="true">
          <svg width="21" height="21" viewBox="0 0 24 24"><path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 14H4v-7h16v7zm0-10H4V6h16v2z"/></svg>
        </span>
        <div><h3>פרטי תשלום</h3><p>כל השדות המסומנים נדרשים להשלמת התשלום</p></div>
      </div>

      <div class="payment-method" aria-label="אמצעי תשלום נבחר">
        <div class="payment-method__title">
          <span class="payment-method__radio" aria-hidden="true"><i></i></span>
          <div><strong>כרטיס אשראי</strong><small>חיוב מאובטח בתשלום אחד</small></div>
        </div>
        <div class="payment-method__brands" aria-label="כרטיסים נתמכים">
          <img [src]="getCardIcon(CreditCardType.VISA)" alt="Visa">
          <img [src]="getCardIcon(CreditCardType.MASTER_CARD)" alt="Mastercard">
          <img [src]="getCardIcon(CreditCardType.AM)" alt="American Express">
          <img [src]="getCardIcon(CreditCardType.DINERS)" alt="Diners">
        </div>
      </div>

      <form #creditCardForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="field-grid">
          <div class="field field--wide">
            <label for="cardholderName">שם בעל הכרטיס</label>
            <input #holderModel="ngModel" type="text" id="cardholderName" [(ngModel)]="cardholderName" name="cardholderName" autocomplete="cc-name" placeholder="השם כפי שמופיע על הכרטיס" required>
            @if (holderModel.invalid && holderModel.touched) { <small class="field-error">יש להזין שם מלא</small> }
          </div>

          <div class="field">
            <label for="email">כתובת אימייל</label>
            <input #emailModel="ngModel" type="email" id="email" [(ngModel)]="email" name="email" autocomplete="email" placeholder="name@example.com" required email>
            @if (emailModel.invalid && emailModel.touched) { <small class="field-error">יש להזין כתובת אימייל תקינה</small> }
          </div>

          <div class="field">
            <label for="phoneNumber">מספר טלפון</label>
            <input #phoneModel="ngModel" type="tel" id="phoneNumber" [(ngModel)]="phoneNumber" name="phoneNumber" autocomplete="tel" inputmode="tel" placeholder="050-0000000" required>
            @if (phoneModel.invalid && phoneModel.touched) { <small class="field-error">יש להזין מספר טלפון</small> }
          </div>

          <div class="field field--wide">
            <label for="cardNumber">מספר כרטיס</label>
            <div class="card-number-wrap" dir="ltr">
              <input #cardModel="ngModel" type="text" id="cardNumber" [(ngModel)]="cardNumber" name="cardNumber" pattern="\d{4} \d{4} \d{4} \d{4}" maxlength="19" inputmode="numeric" autocomplete="cc-number" placeholder="0000 0000 0000 0000" required (input)="onCardNumberChange()">
              <div class="card-brands" aria-label="סוגי כרטיסים נתמכים">
                @if (isCardType(CreditCardType.VISA)) { <img [src]="getCardIcon(CreditCardType.VISA)" alt="Visa"> }
                @if (isCardType(CreditCardType.MASTER_CARD)) { <img [src]="getCardIcon(CreditCardType.MASTER_CARD)" alt="Mastercard"> }
                @if (isCardType(CreditCardType.AM)) { <img [src]="getCardIcon(CreditCardType.AM)" alt="American Express"> }
                @if (isCardType(CreditCardType.DINERS)) { <img [src]="getCardIcon(CreditCardType.DINERS)" alt="Diners"> }
              </div>
            </div>
            @if (cardModel.invalid && cardModel.touched) { <small class="field-error">יש להזין 16 ספרות תקינות</small> }
          </div>

          <div class="field">
            <label for="expirationDate">תוקף הכרטיס</label>
            <input #expiryModel="ngModel" dir="ltr" type="text" id="expirationDate" [(ngModel)]="expirationDate" name="expirationDate" maxlength="5" inputmode="numeric" autocomplete="cc-exp" pattern="(0[1-9]|1[0-2])\/\d{2}" placeholder="MM/YY" required (input)="onExpirationDateChange()">
            @if (expiryModel.invalid && expiryModel.touched) { <small class="field-error">יש להזין תוקף בפורמט MM/YY</small> }
          </div>

          <div class="field">
            <label for="cvv">קוד אבטחה CVV <span class="help-dot" title="3 הספרות בגב הכרטיס">?</span></label>
            <input #cvvModel="ngModel" dir="ltr" type="password" id="cvv" [(ngModel)]="cvv" name="cvv" maxlength="3" inputmode="numeric" autocomplete="cc-csc" pattern="\d{3}" placeholder="•••" required (input)="onCvvChange()">
            @if (cvvModel.invalid && cvvModel.touched) { <small class="field-error">יש להזין 3 ספרות</small> }
          </div>
        </div>

        <input type="hidden" [(ngModel)]="numOfPays" name="installments">

        @if (paymentError) { <div class="payment-error" role="alert">{{ paymentError }}</div> }

        @if (payProcess == PaymentProcessStatus.DONE) {
          <div class="payment-success" role="status">
            <span aria-hidden="true">✓</span>
            <div><strong>התשלום בוצע בהצלחה</strong><small>מעבירים אתכם לשלב הבא...</small></div>
          </div>
        } @else {
          <button class="pay-button" type="submit" [disabled]="!CheckIfValid(creditCardForm) || payProcess == PaymentProcessStatus.IN_PROGRESS">
            @if (payProcess == PaymentProcessStatus.IN_PROGRESS) {
              <span class="button-spinner" aria-hidden="true"></span> מעבדים את התשלום...
            } @else {
              תשלום מאובטח {{ adsRoute?.price | number:'1.0-2' }} ₪
              <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M17 8h-1V6a4 4 0 00-8 0v2H7a2 2 0 00-2 2v10h14V10a2 2 0 00-2-2zm-7-2a2 2 0 014 0v2h-4V6zm7 12H7v-8h10v8z"/></svg>
            }
          </button>
        }

        <div class="checkout-assurances">
          <span><i aria-hidden="true">✓</i> ללא עמלות נסתרות</span>
          <span><i aria-hidden="true">✓</i> אישור מיידי</span>
          <span><i aria-hidden="true">✓</i> הצפנת SSL</span>
        </div>

        <div class="secure-note">
          <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l8 3v6c0 5.05-3.41 9.74-8 11-4.59-1.26-8-5.95-8-11V5l8-3z"/></svg>
          פרטי הכרטיס מועברים בצורה מוצפנת ואינם נשמרים באתר
        </div>
      </form>
    </div>
  </div>
</section>
